import { useMemo } from 'react';
import { useWorkspace } from '../../providers/WorkspaceProvider';
import { useWorkspacePermissions } from '../../providers/WorkspacePermissionsProvider';
import { useTranslation } from 'react-i18next';
import { createExcelFormatter } from '@opas-mobile/report-export';
import { getLocalTime } from '../../utilities/time';

// Thin wrapper around the shared package's createExcelFormatter, so this
// and the backend's own Excel export (opas-api's generateCustomReportXlsx)
// can never drift apart again — this used to be its own independent copy
// of the same formatting logic, which is exactly how it ended up missing
// fixes (date fields, participants, timezone handling) made to the
// package's copy but never mirrored here.
export function useExcelFormatter() {
  const { t } = useTranslation();
  const { allWorkspaces = [], allVehicles = [] } = useWorkspace() ?? {};
  const { allUsers = [] } = useWorkspacePermissions() ?? {};

  const formatter = useMemo(
    () =>
      createExcelFormatter({
        t,
        users: allUsers,
        workspaces: allWorkspaces,
        vehicles: allVehicles,
        getTime: getLocalTime,
      }),
    [t, allUsers, allWorkspaces, allVehicles],
  );

  return formatter;
}
